import { render, staticRenderFns } from "./OrigemDestinoFdnew.vue?vue&type=template&id=789dc9d9&"
import script from "./OrigemDestinoFdnew.vue?vue&type=script&lang=js&"
export * from "./OrigemDestinoFdnew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports